// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2C6td","signatureButtonsRight":"ModalSign_signatureButtonsRight__R16iG"};